<template>
  <form class="auth_register-form" @submit.prevent="createUser" autocomplete="on" novalidate>
    <Input
      name="login"
      class="auth_register-form__login"
      v-model="form.login"
      placeholderKey="form.register.placeholder.login"
      ref="form.loginInput"
      autocomplete="username"
      :validationDelay="999999"
      :validate="validateLogin"
      :required="true"
      @update:modelValue="inputChanged"
    >
      {{ $t('form.register.login') }}
    </Input>
    <Input
      name="email"
      class="auth_register-form__email"
      v-model="form.email"
      placeholderKey="form.register.placeholder.email"
      ref="form.emailInput"
      autocomplete="email"
      :validationDelay="999999"
      :validate="validateEmail"
      required
      @update:modelValue="inputChanged"
    >
      {{ $t('form.register.email') }}
    </Input>
    <Input
      type="password"
      name="password"
      class="auth_register-form__password"
      v-model="form.password"
      placeholderKey="form.register.placeholder.password"
      ref="form.passwordInput"
      :validate="validatePassword"
      required
      autocomplete="new-password"
      @update:modelValue="inputChanged"
    >
      {{ $t('form.register.password') }}
    </Input>
    <Input
      type="password"
      name="passwordRepeat"
      class="auth_register-form__password-repeat"
      v-model="form.passwordRepeat"
      placeholderKey="form.register.placeholder.password_repeat"
      ref="form.passwordRepeatInput"
      :validate="validateRepeatPassword"
      required
      autocomplete="new-password"
      @update:modelValue="inputChanged"
    >
      {{ $t('form.register.password_repeat') }}
    </Input>
    <FormControls :errorMessage="errorMessage" :state="state" buttonText="form.register.button.submit" />
  </form>
</template>

<script>
  import NetworkMixin    from "./network_mixin";
  import ValidationMixin from "./validation_mixin";
  import { Input, FormControls } from "../../elements";
  import { eventBus, EVENTS } from "../../event_bus.js";

  export default {
    name: 'RegisterForm',
    components: {
      Input,
      FormControls
    },
    mixins: [NetworkMixin, ValidationMixin],
    data() {
      return {
        form: {
          login: "",
          email: "",
          password: "",
          passwordRepeat: "",
          token: "",
        },
        errorMessage: "",
        state: "DEFAULT"
      }
    },
    methods: {
      createUser() {
        if (!this.isFormValid()) {
          this.errorMessage ="form.register.error.FORM_INVALID";
        }
        if (this.errorMessage || this.state != "DEFAULT") {
          return;
        }
        this.state = "LOADING";
        this.networkRegisterUser(this.form).then(response => {
          this.state = "DEFAULT";
          if (response.data.success) {
            eventBus.$emit(EVENTS.User.Register.Success);
            eventBus.$emit(EVENTS.User.Auth.Success);
          }
        }).catch(err => {
          this.state = "DEFAULT";
          if (err.status) {
            this.errorMessage = `form.register.error.${err.status}`;
          }
          eventBus.$emit(EVENTS.User.Register.Fail, err);
          eventBus.$emit(EVENTS.User.Auth.Fail, err);
        });
      },
      inputChanged() {
        if (this.errorMessage) {
          this.errorMessage = "";
        }
      }
    },
    created() {
      this.networkCreateRequestAuthToken().then(response => {
        this.form.token = response.data.content.token;
      });
    }
  }
</script>
